module.exports = __webpack_public_path__ + "static/media/about img1.dd497337.webp";